import ComponentePermissao from "@/Components/Base/Permissao/ComponentePermissao";
import TablePaginadaBasic from "@/Components/Base/Table/TablePaginadaBasic";
import { PaginaInfo } from "@/Models/Utils/Pagina/Pagina";
import { IViagemSintenticaParamComPagina, useViagemSintenticaPagina, ViagemSintenticaListar } from "@/Services/Domain/Relatorio/VuagemSinteticaService";
import Utilitario from "@/Utils/Utilitario";
import { Button, Col, Form, Grid, Input, Row, Typography } from "antd";
import { Link } from "react-router-dom";
import ViagemSelect from "./ViagemSelect";
import InputRangePicker from "@/Components/Base/Input/InputRangePicker";
import dayjs, { Dayjs } from "dayjs";
import { useEffect } from "react";

export interface IViagemSintenticaScreenProps {

}
export default function ViagemSintenticaScreen({

}:IViagemSintenticaScreenProps) {
    const [form] = Form.useForm<IViagemSintenticaParamComPagina>();
    const parametros = Form.useWatch([], form);

    const breakpoint = Grid.useBreakpoint();    
    const initIntervalo = [dayjs().startOf('year'), dayjs().endOf('year')];

    const {
        data,
        refetch
    } = useViagemSintenticaPagina({
        paginaInfo : parametros?.paginaInfo,
        codViagens : parametros?.codViagens,
        intervalo : parametros?.intervalo,
        enabled : false && !!parametros?.paginaInfo
    });

    useEffect(() => {
        refetch();
    }, [parametros?.paginaInfo]);

    return <ComponentePermissao tipo="any" permissoes={["ListarInscricoesDaViagem", "DomainViagemRelatorioRelatorioAnaliticoDeViagens"]}>
        <Form<IViagemSintenticaParamComPagina>
            form={form}
            layout="vertical"
            initialValues={{
                intervalo: initIntervalo,
                paginaInfo: new PaginaInfo(),
                codViagens: []
            }}
            onFinish={(v) => {
                refetch();
            }}
        >
            <Row gutter={[8, 8]}>
                <Form.Item<IViagemSintenticaParamComPagina> name="paginaInfo" hidden><Input hidden/></Form.Item>
                
                <Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={4}>
                    <Form.Item<IViagemSintenticaParamComPagina>
                        name={"intervalo"} 
                        label="Intervalo" 
                        rules={[
                            {
                                required : true
                            }
                        ]}
                    >
                        <InputRangePicker
                            disabledDate={(dia, v) => {
                                if (v.from) {
                                    if (dia < v.from) return true;
                                    if (dia > v.from.add(1, "year")) return true;
                                }
                                return false;
                            }}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={13} lg={14} xl={16} xxl={18}>
                    <Form.Item<IViagemSintenticaParamComPagina> name={"codViagens"} label={"Viagens"}>
                        <ViagemSelect 
                            mode="multiple"
                            dataInicial={parametros?.intervalo?.[0]?.isValid?.() ? parametros.intervalo[0].toDate?.() : undefined}
                            dataFinal={parametros?.intervalo?.[1]?.isValid?.() ? parametros.intervalo[1].toDate?.() : undefined}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} sm={24} md={3} lg={2} xl={2} xxl={2}>
                    <Form.Item label={breakpoint.md ? <></> : undefined}>
                        <Button style={{ width: "100%" }} type="primary" htmlType="submit">
                            Listar
                        </Button>
                    </Form.Item>
                </Col>

                <Col xs={24}>
                    <TablePaginadaBasic
                        onChange={(pagina) => {
                            form.setFieldValue(["paginaInfo"], {
                                pagina : pagina.current ?? 1,
                                tamanho : pagina.pageSize ?? 15
                            });
                        }}
                        bordered
                        locale={{ emptyText: 'Nenhuma viagem foi encontrada.' }}
                        dataSource={data}
                        disableResponsiveness={true}
                        tableLayout="auto"
                        scroll={{
                            x: true,
                        }}
                        showHeader={true}
                        minColWidthIfResponsivenessDisabled={"120px"}
                        loading={false}
                        rowKey={(k) => k.codViagem}
                        csv={{
                            enabled : true,
                            concat(source) {
                                return [{
                                    header : "Inscrições",
                                    data : source.map(record => `${window.location.origin}/viagens/viagens/detalhes?id=${record.codViagem}&tela_viagem_aba_inicial=inscricoes`)
                                }]
                            },
                            filename : "Viagens.csv",
                            acquireSource() {
                                return ViagemSintenticaListar({
                                    codViagens : parametros?.codViagens,
                                    intervalo : parametros?.intervalo
                                });
                            },
                        }}
                        columns={[
                            {
                                title : "Escola",
                                dataIndex : "nomeEscola",
                                key : "nomeEscola",
                                minWidth : "200px"
                            },
                            {
                                title : "Destino",
                                dataIndex : "nomeDestino",
                                key : "nomeDestino",
                                minWidth : "200px",
                                render(value, record, index) {
                                    return <Link target={"_blank"} to={`/viagens/viagens/detalhes?id=${record.codViagem}&tela_viagem_aba_inicial=inscricoes`}>{value}</Link>
                                }
                            },
                            {
                                title : "Turma",
                                dataIndex : "turma",
                                key : "turma",
                                minWidth : "50px",
                            },
                            {
                                title : "Inscritos",
                                dataIndex : "totalInscritos",
                                key : "totalInscritos",
                                minWidth : "50px"
                            },
                            {
                                title : "Pagos",
                                dataIndex : "totalInscritosPagos",
                                key : "totalInscritosPagos",
                                minWidth : "50px"
                            },
                            {
                                title : "Prazo de pagt.",
                                dataIndex : "dataPrazoPagamento",
                                key : "dataPrazoPagamento",
                                minWidth : "100px",
                                render(value, record, index) {
                                    return Utilitario.dateToString(value);
                                }
                            },
                            {
                                title : "Saída",
                                dataIndex : "dataInicio",
                                key : "dataInicio",
                                minWidth : "80px",
                                render(value, record, index) {
                                    return Utilitario.dateToString(value);
                                }
                            },
                            {
                                title : "Retorno",
                                dataIndex : "dataFim",
                                key : "dataFim",
                                minWidth : "80px",
                                render(value, record, index) {
                                    return Utilitario.dateToString(value);
                                }
                            },
                            {
                                title : "Valores",
                                dataIndex : "valores",
                                key : "valores",
                                minWidth : "275px",
                                render(value:Array<string>, record, index) {
                                    if ((value ?? []).length == 0) return undefined;

                                    return <>
                                        {(value ?? []).map((m, i) => <>{i == 0 ? undefined :<br />}{m}</>)}
                                    </>;
                                },
                                csv : {
                                    get(value) {
                                        return (value?.valores ?? []).join(' | ');
                                    },
                                }
                            },
                            {
                                title : "Apresentação",
                                dataIndex : "linkApresentacao",
                                key : "linkApresentacao",
                                minWidth : "100px",
                                render(value, record, index) {
                                    return !!value ? <Link target={"_blank"} to={value}>Acessar</Link> : undefined;
                                },
                                csv : {
                                    get(value) {
                                        return value?.linkApresentacao ?? '-';
                                    }, 
                                }
                            }
                        ]}
                    />
                </Col>
            </Row>
        </Form>
    </ComponentePermissao>;
}